import { Reveal, SectionHeading } from "./Reveal";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1546707012-c46675f12716?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxjb25jZXJ0JTIwc3RhZ2UlMjBibHVlJTIwbGlnaHQlMjBjcm93ZHxlbnwwfHx8fDE3OTA5NjIyODl8MA&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Crowd of spectators at an esports event under dramatic blue stage lighting",
    caption: "Esports Arena",
    span: "col-span-2 row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1599749260006-b7ad9ea64068?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOUp8MHwxfHNlYXJjaHwxfHxyYWNpbmclMjBzaW11bGF0b3IlMjBzdGVlcmluZyUyMHdoZWVsJTIwZGFya3xlbnwwfHx8fDE3OTA5NjIyNzV8MA&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Close-up of a racing simulator steering wheel in a dark cockpit",
    caption: "Cockpit Detail",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzN8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwc2NyZWVuJTIwZGFya3xlbnwwfHx8fDE3OTA5NjIyODB8MA&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Wide view of a convention hall stage with large screens in dark ambience",
    caption: "Expo Floor",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1596040078821-9b5f50e71ea5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzN8MHwxfHNlYXJjaHszfHxjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwc2NyZWVuJTIwZGFya3xlbnwwfHx8fDE3OTA5NjIyODB8MA&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Corporate brand activation space with a large screen and dark ambience",
    caption: "Brand Activation",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1614179924047-e1ab49a0a0cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxnYW1pbmclMjBzZXR1cCUyMG5lb24lMjBibHVlJTIwcmlnfGVufDB8fHx8MTc5MDk2MjI4OXww&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Racing simulator rig in a dark room with neon blue lighting",
    caption: "Sim Bay",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1760553121003-93afc4d88ae0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6ODh8MHwxfHNlYXJjaHszfHxyYWNpbmclMjBzaW11bGF0b3IlMjB0cmFkZSUyMHNob3clMjBldmVudHxlbnwwfHx8fDE3OTA5NjE5MDl8MA&ixlib=rb-4.1.0&q=75&w=1000",
    alt: "Racing simulator activation live at a trade show event",
    caption: "Race Control",
    span: "",
  },
];

export const Gallery = () => (
  <section id="gallery" className="relative py-20 lg:py-28 border-t border-line" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Gallery"
        title={
          <>
            Activations <span className="text-electric">In Action</span>
          </>
        }
        sub="A look at recent booths, launches and brand experiences powered by Impact Activations."
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] gap-4 mt-14">
        {IMAGES.map((img, i) => (
          <Reveal key={img.caption} delay={i * 0.06} className={img.span} y={24}>
            <figure
              className="relative h-full w-full overflow-hidden border border-line group clip-corner"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
              <figcaption className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-electric">
                {img.caption}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
